import type { ReactNode } from 'react'
import { cx } from '../../lib/cx'
import { Icon, type IconName } from '../Icon'
import type { ChipTone } from './statuses'

export interface StatusChipProps {
  tone?: ChipTone
  /** Defaults to an icon for the tone, so the state never rests on colour alone. */
  icon?: IconName | null
  children: ReactNode
  className?: string
}

const TONE_ICON: Record<ChipTone, IconName | null> = {
  neutral: null,
  success: 'check_circle',
  warning: 'hourglass_top',
  danger: 'error',
  info: 'info',
}

/** A status in words, an icon and a tint: "Paid", "Waiting for approval", "Overdue". */
export function StatusChip({ tone = 'neutral', icon, children, className }: StatusChipProps) {
  const shown = icon === undefined ? TONE_ICON[tone] : icon
  return (
    <span className={cx('status-chip', `status-chip--${tone}`, className)}>
      {shown && <Icon name={shown} size={16} />}
      <span>{children}</span>
    </span>
  )
}
